import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, DatePicker, Icon, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
// import './style/home.less';
import { saveSearchParams } from '../../../actions/rankActions';

const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';

class RankTable extends Component {
    state = {
        list: [],
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const maxDate = `${res.year}-${res.month < 10 ? `0${res.month}` : res.month}`;
            this.setState({
                maxDate,
                inspectionTime: moment(maxDate),
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { maxDate, inspectionTime = null } = this.state;
        this.setState({ loading: true });
        const date = inspectionTime ? inspectionTime.format(monthFormat) : maxDate;

        const options = {
            method: 'POST',
            url: API_URL.home.queryUserInternalRecommendIdList,
            data: {
                inspectionTime: date,
                limit: 10,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    meanValue: res.avg,
                    list: res.result.datas,
                });
            }
        }
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [
            {
                title: '排名',
                dataIndex: 'rank',
                width: 60,
            }, {
                title: '团队领导',
                dataIndex: 'userCompellation',
                render: (text, record) => `${record.userCompellation}[${record.employeeCode}]`,
                width: 200,
            }, {
                title: '职位级别',
                dataIndex: 'positionName',
                width: 150,
            }, {
                title: '团队推荐转正人数',
                dataIndex: 'peopleCount',
                width: 150,
            },
        ];
        return columns;
    }

    getDataSource = () => {
        const { list } = this.state;
        const dataSource = list.map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    handleDateChange = (date, dateString) => {
        this.setState({ inspectionTime: date }, () => {
            this.loadData();
        });
    }

    prevMonth = () => {
        const { inspectionTime } = this.state;
        this.setState({ inspectionTime: inspectionTime.subtract(1, 'M') }, () => {
            this.loadData();
        });
    }

    nextMonth = () => {
        const { inspectionTime, maxDate } = this.state;
        const newMonthDate = moment(inspectionTime.format(monthFormat)).add(1, 'M');
        if (newMonthDate.valueOf() > moment(maxDate).valueOf()) {
            message.warning('不能大于该月份！');
            return;
        }
        this.setState({ inspectionTime: newMonthDate }, () => {
            this.loadData();
        });
    }

    disabledDate = (current) => {
        const { maxDate } = this.state;
        const value = moment(maxDate).valueOf();
        return current && current.valueOf() > value;
    }

    goToRank = () => {
        const { maxDate = '', inspectionTime = null } = this.state;
        const performanceState = { params: {} };
        this.props.saveParams(performanceState);
        location.href = `/#/teamRecommendTalentRank/${inspectionTime ? inspectionTime.format(monthFormat) : maxDate}`;
    }

    render() {
        const { inspectionTime = null, loading } = this.state;
        return (
            <article className="performanceTable flexItem outer">
                <header className="modTitle">团队推荐转正人才排名</header>
                <content className="boby">
                    <header className="monthSelect1">
                        <Icon type="left-circle-o" style={{ color: '#5850C9' }} onClick={this.prevMonth} />
                        <MonthPicker allowClear={false} value={inspectionTime} format={monthFormat} onChange={this.handleDateChange} disabledDate={this.disabledDate} />
                        <Icon type="right-circle-o" style={{ color: '#5850C9' }} onClick={this.nextMonth} />
                    </header>
                    <div className="tableWrap">
                        <Table
                            bordered={false}
                            loading={loading}
                            pagination={false}
                            scroll={{ x: 558 }}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.index}
                        />
                    </div>
                </content>
                <footer className="footer">
                    <a className="more" onClick={this.goToRank}>{`查看更多>>`}</a>
                </footer>
            </article>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveSearchParams(params))
})

export default connect(null, mapDispatchToProps)(RankTable);


// WEBPACK FOOTER //
// ./src/components/homePage/performanceRank/TalentRank.js